<template>
  <div>
    <b-card class="mx-auto layered box" tile>
      <b-tabs v-model="tabManager" content-class="mt-3" justified>
        <!-- Pestaña para las alertas -->
        <b-tab title-item-class="headTab" :title="'Alertas'">
          <section id="inputs">
            <div class="row mb-3">
              <div class="col-xs-6 col-md-4 col-lg-5">
                <label for="tipobusqueda"> {{ $t('vEstadisticas.tipoBusqueda') }}: </label>
                <b-form-select id="tipobusqueda" v-model="filterType" :options="translateTipoBusqueda"
                  required></b-form-select>
              </div>
              <div v-if="!isGeneralView" class="col-xs-6 col-md-5 col-lg-5 separacion-div-rango-fecha">
                <label for="rangoFechas">{{ $t('Gral.rangoFechas') }}:</label>
                <DatePicker id="rangoFechas" class="form-control form-textarea" :ocultarLabel="ocultarLabel"
                  :ocultarBoton="ocultarBoton" @inputDate="inputDate" />
              </div>
              <div v-if="!isGeneralView"
                class="col-xs-6 col-md-3 col-lg-2 d-flex align-items-end separacion-div-boton-buscar">
                <b-btn class="d-flex align-items-center justify-content-center w-100" style="color: white"
                  variant="info" text @click="enableChart(tabManager)" color="blue" :disabled="!habilitarBoton">
                  <feather type="search" class="feather-sm mr-2"></feather> {{ $t('vBitacora.consultar') }}
                </b-btn>
              </div>
            </div>
          </section>
          <!-- Renderización de la gráfica para las últimas alertas. -->
          <section>
            <div class="container-general" v-if="isGeneralView">
              <div class="container-apex" v-if="isAlertsAvailables">
                <apex-chart :datos="alertsList" :enum="1" :total="totalAlerts" />
              </div>
              <div class="container-empty" v-else>
                <empty-state-component :enum="1"></empty-state-component>
              </div>
            </div>
            <!-- Renderización de la gráfica para alertas por rango de fechas. -->
            <div v-else id="rango">
              <div v-if="isClicBtnConsult">
                <div v-if="isAlertsAvailables">
                  <daily-chart :enum="1" :rawData="alertasss" :fechas="fechasss" :total="lbltotalAlertas" />
                </div>
                <div v-else>
                  <empty-state-component :enum="2"></empty-state-component>
                </div>
              </div>
            </div>
          </section>
        </b-tab>
        <!-- Pestaña para las Geocercas -->
        <b-tab title-item-class="headTab" :title="$t('Geocercas')">
          <section id="configuracion">
            <div class="row mb-3">
              <div class="col-xs-6 col-md-4 col-lg-5">
                <label for="tipoBusquedaGeo">{{ this.$t('vEstadisticas.tipoBusqueda') }}:</label>
                <b-form-select id="tipoBusquedaGeo" v-model="filterType" :options="translateTipoBusqueda" required>
                </b-form-select>
              </div>
              <div v-if="!this.isGeneralView" class="col-xs-6 col-md-5 col-lg-5 separacion-div-rango-fecha">
                <label for="rangoFechaGeo">{{ $t('Gral.rangoFechas') }}:</label>
                <DatePicker id="rangoFechaGeo" class="form-control form-textarea" :ocultarLabel="ocultarLabel"
                  :ocultarBoton="ocultarBoton" @inputDate="inputDate" />
              </div>
              <div v-if="!this.isGeneralView"
                class="col-xs-6 col-md-3 col-lg-2 d-flex align-items-end separacion-div-boton-buscar">
                <b-btn class="d-flex align-items-center justify-content-center w-100" style="color: white"
                  variant="info" text @click="enableChart(tabManager)" color="blue" :disabled="!habilitarBoton">
                  <feather type="search" class="feather-sm mr-2"></feather> {{ $t('vBitacora.consultar') }}
                </b-btn>
              </div>
            </div>
          </section>
          <!-- Renderización de la gráfica para las últimas geocercas. -->
          <section>
            <div class="container-general" v-if="isGeneralView">
              <div class="container-apex" v-if="isAlertsAvailables">
                <apex-chart :datos="geofencesList" :enum="2" :total="totalAlerts" />
              </div>
              <div v-else>
                <empty-state-component :enum="3"></empty-state-component>
              </div>
            </div>
            <!-- Renderización de la gráfica para geocercas por rango de fechas. -->
            <div v-else>
              <div v-if="isClicBtnConsult">
                <div v-if="isAlertsAvailables">
                  <daily-chart :enum="2" :rawData="geocercasArray" :fechas="fechasss" :total="lbltotalAlertas" />
                </div>
                <div v-else>
                  <empty-state-component :enum="4"></empty-state-component>
                </div>
              </div>
            </div>
          </section>
        </b-tab>
        <!-- Pestaña para los dispositivos -->
        <b-tab title-item-class="headTab" :title="$t('Dispositivos')">
          <section id="inputs2">
            <b-form @submit.stop.prevent="enableChart(tabManager)" style="z-index: 1" class="ml-2">
              <h4 style="margin-top: 25px; margin-bottom: 25px;"> {{ $t('vEstadisticas.msgSelectDispo') }}</h4>
              <div class="row mb-3">
                <div class="col-xs-6 col-md-5 col-lg-5 col-xl-5">
                  <label for="dispositivos">{{ $t('Dispositivos') }}:</label>
                  <Multiselect id="dispositivos" v-model="selectedDispositivo" :searchable="true"
                    :options="dispositivosTodos" :multiple="false" :selectLabel="$t('vHistorico.presioneAgregar')"
                    :selectedLabel="$t('vHistorico.seleccionado')" :deselectLabel="$t('vHistorico.presioneEliminar')"
                    :placeholder="$t('vHistorico.selecDispo')" track-by="nombre" label="nombre" @input="inputSelect">
                    <span slot="noResult">{{ $t('vHistorico.msgBusquedaFallida') }}</span>
                  </Multiselect>
                </div>
                <div class="col-xs-6 col-md-4 col-lg-5 col-xl-5 separacion-div-rango-fecha">
                  <label for="rangoFechasdispo">{{ $t('Gral.rangoFechas') }}:</label>
                  <DatePicker id="rangoFechasdispo" class="form-control form-textarea" :ocultarLabel="ocultarLabel"
                    :ocultarBoton="ocultarBoton" @inputDate="inputDate" />
                </div>
                <div class="col-xs-6 col-md-3 col-lg-2 col-xl-2 separacion-div-boton-buscar-dispo">
                  <label for="btnconsultar" style="visibility: hidden;">btnConsultar</label>
                  <b-btn id="btnconsultar" class="d-flex align-items-center justify-content-center w-100"
                    style="color: white" variant="info" text type="submit" color="blue" :disabled="!habilitarBoton">
                    <feather type="search" class="feather-sm mr-2"></feather> {{ $t('vBitacora.consultar') }}
                  </b-btn>
                </div>
              </div>
            </b-form>
          </section>
          <!-- Gráficas para alertas por dispositivo -->
          <section>
            <div v-if="isDeviceSelected">
              <div v-if="isClicBtnConsult">
                <div v-if="!isAlertsAvailables && !isGeosAvailables">
                  <empty-state-component :enum="5"></empty-state-component>
                </div>
                <div v-else>
                  <!-- Renderización de la gráfica para alertas por rango de fechas. -->
                  <div v-if="isAlertsAvailables">
                    <daily-chart :enum="3" :id="idDevice" :rawData="alertasByDevice" :fechas="fechasss"
                      :total="lbltotalAlertas" />
                  </div>
                  <div v-else>
                    <empty-state-component :enum="2"></empty-state-component>
                  </div>
                  <!-- Renderización de la gráfica para geocercas por rango de fechas. -->
                  <div v-if="isGeosAvailables">
                    <daily-chart :enum="4" :id="idDevicee" :rawData="geosByDevice" :fechas="fechass"
                      :total="lbltotalAlertass" />
                  </div>
                  <div v-else>
                    <empty-state-component :enum="4"></empty-state-component>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import { mapState } from "vuex";

//Servicios
import AlertasDataService from "../../../services/AlertasDataService";
import DevicesDataService from "../../../services/DevicesDataService";
import Crypto from "../../../services/Crypto";

//Componentes
import EmptyStateComponent from './EmptyStateComponent.vue';
import Multiselect from "vue-multiselect";
import flatPickr from "vue-flatpickr-component";
import ApexChart from './GraficaDiaria';
import DailyChart from './GraficaFechas';
import "flatpickr/dist/flatpickr.css";
import "flatpickr/dist/themes/material_blue.css";
import * as Utils from "../../../utils/Utils"
import { verificarAcceso } from '../../../utils/Session';

import DatePicker from "../../components/DateRangePicker.vue";

export default {
  components: {
    flatPickr,
    Multiselect,
    ApexChart,
    DailyChart,
    EmptyStateComponent,
    DatePicker
  },
  data() {
    return {
      /** Bandera que permite identificar si la busqueda será general */
      isGeneralView: true,
      /** Bandera que permite saber si hay alertas obtenidas de las consultas realizadas a bd */
      isAlertsAvailables: false,
      /** Bandera que permite saber si hay geocercas obtenidas de las consultas realizadas a bd */
      isGeosAvailables: false,
      /** Bandera encargada de verificar si se ha hecho clic en el botón consultar para las graficas que usan fechas */
      isClic: false,
      /** Bandera que permite identificar si hay un dispositivo seleccionado */
      isDeviceSelected: false,
      /** Variable encargada de contener el indice de las pestania del tipo de grafica seleccionada */
      tabManager: 0,
      /** Variable encargada de identificar si la busqueda será general o por rango de fechas */
      filterType: "byLatest",
      /** Variable encargado de contener el modelo de fechas del flat */
      modelDateRange: null,

      /** Objeto que almacena los items para el tipo de búsqueda */
      searchOptions: [
        { value: "byLatest", text: "ultimas" },
        { value: "byDateRange", text: "fechas" },
      ],

      /** Objeto que almacena las fecha inicial y final para las consultas con rango de fechas */
      fecha: {
        inicial: null,
        final: null
      },
      /** Variable que almacena el objeto dispositivo seleccionado de la lista de dispositivos */
      selectedDispositivo: null,
      /** Variable que almacena la lista de todos los dispositivos que se encuentran registrados en el sistema */
      dispositivosTodos: [],
      /** Variable que almacena el ID de algún dispositivo seleccionado */
      idDispositivo: null,
      /** Variable que almacena la key */
      key: "",
      /** Variable que almacena la lista de alertas recientes obtenidas de la DB */
      alertsList: {},
      /** Variable que almacena la lista de alertas recientes de tipo GEOCERCAS obtenidas de la DB */
      geofencesList: {},
      /** Variable que almacena la lista de las alertas obtenidas dentro de un intervalo de fechas obtenidas de la DB */
      alertasss: {},
      /** Variable que almacena la lista de las alertas de tipo GEOCERCA obtenidas dentro de un intervalo de fechas obtenidas de la DB */
      geocercasArray: {},
      /** Variable que almacena la lista de las alertas registradas de un dispositivo */
      alertasByDevice: {},
      /** Variable que almacvena la lista de alertas de tipo GEOCERCA registradas de un dispositivo */
      geosByDevice: {},

      fechasss: null,
      fechass: null,
      lbltotalAlertas: 0,
      lbltotalAlertass: 0,
      idDevice: '',
      idDevicee: '',
      ocultarLabel: true,
      ocultarBoton: true,
      habilitarBoton: false,
      trackBy: 'nombre'
    }
  },
  mounted() {
    this.getLatestAlerts();
    this.key = sessionStorage.getItem('key');
  },
  computed: {
    ...mapState(['locale']),
    translateTipoBusqueda() {
      return this.translateOptions(this.searchOptions)
    },
    validarBotonConsultar() {
      if (this.tabManager === 2) {
        return !(this.modelDateRange !== null && this.isDeviceSelected);
      } else {
        return !this.modelDateRange;
      }
    },
    isClicBtnConsult() {
      return !!this.isClic
    }
  },

  watch: {
    /**
     * Método encargado de observar el tipo de búsqueda a realizar,
     * true : para busquedas en general;
     * false : para busquedas por rango de fechas
     * @param value estado del item
     */
    filterType(value) {
      if (value === 'byDateRange') {
        if (this.tabManager === 2) {
          this.isAlertsAvailables = false;
        }
      }

      this.isGeneralView = value === 'byLatest';
      this.limpiarCampos(this.isGeneralView);
    },

    /** Método encargado de identificar en que pestania de las gráficas se encuentra el foco*/
    tabManager(value) {
      this.managerReset();
      if (value === 0) {
        this.getLatestAlerts();
      } else if (value === 1) {
        this.getLatestGeos();
      } else if (value === 2) {
        this.getDevices();
      }
    }

  },

  beforeCreate() {
    verificarAcceso();
  },
  methods: {
    // === SECCIÓN DE MÉTODOS DE CONSULTAS === //
    inputDate(date) {
      if (date.start !== null && date.end !== null) {
        this.fecha.inicial = date.start;
        this.fecha.final = date.end;
        this.habilitarBotonConsultar();
      }
    },

    habilitarBotonConsultar() {
      if (this.fecha.inicial && this.fecha.final) {
        this.habilitarBoton = true;
      }
    },

    /** Método encargado de habilitar la grafica correspondiente
   * @param value índice de la pestaña de la caracteristica a graficar.
   */
    enableChart(value) {
      this.isClic = false

      switch (value) {
        case 0:
          this.isClic = !this.isClic;
          this.getAlertsByDates();
          break;
        case 1:
          this.isClic = !this.isClic;
          this.getGeofencesByDates();
          break;
        case 2:
          this.isClic = !this.isClic;
          this.fetchAlertsAndGeofences()
          break;
        default:
      }
    },

    /** Método encargado de obtener las últimas alertas registradas en el sistema.*/
    async getLatestAlerts() {
      try {
        const response = await AlertasDataService.getLatestGroupedAlerts();
        const alerts = await Crypto.desencriptar(response.data, this.key);
        this.totalAlerts = Object.values(alerts).reduce((a, b) => a + b, 0);
        this.isAlertsAvailables = this.totalAlerts > 0;
        if (this.isAlertsAvailables) {
          this.alertsList = alerts;
        }
      } catch (error) {
        console.error("Error al obtener las ultimas alertas: ", error);
        Utils.generalSweetAlert(this.$t('Gral.msgErrorDesconocido'), 'error');
      }
    },

    /**
    * Método encargado de obtener las últimas geocercas interceptadas en el sistema.
    */
    async getLatestGeos() {
      try {
        const response = await AlertasDataService.getLatestGroupedGeofences();
        const alerts = await Crypto.desencriptar(response.data, this.key);
        this.totalAlerts = Object.values(alerts).reduce((a, b) => a + b, 0);
        this.isAlertsAvailables = this.totalAlerts > 0;
        if (this.isAlertsAvailables) {
          this.geofencesList = alerts;
        }
      } catch (error) {
        console.error("Error al obtener las ultimas geocercas: ", error);
        Utils.generalSweetAlert(this.$t('Gral.msgErrorDesconocido'), 'error');
      }
    },

    /** Método encargado de obtener las alertas registradas en un rango de fechas establecidas.
    */
    async getAlertsByDates() {
      const data = {
        fechaInicial: this.fecha.inicial,
        fechaFinal: this.fecha.final,
      };

      try {
        const response = await AlertasDataService.getAlertsGroupedByDates(data, this.key);
        const alerts = await Crypto.desencriptar(response.data, this.key);
        const totalAlerts = this.getTotalAlerts(alerts);
        this.isAlertsAvailables = totalAlerts > 0;
        if (this.isAlertsAvailables) {
          this.fechasss = data;
          this.alertasss = alerts;
          this.lbltotalAlertas = totalAlerts;
        }
      } catch (error) {
        console.error("Error al obtener las ultimas alertas por rango de fechas: ", error);
        Utils.generalSweetAlert(this.$t('Gral.msgErrorDesconocido'), 'error');
      }
    },

    /** 
    * Método encargado de obtener las alertas de tipo
    * geocerca que corresponden a Entradas y Salidas.
    */
    async getGeofencesByDates() {
      const data = {
        fechaInicial: this.fecha.inicial,
        fechaFinal: this.fecha.final,
      };

      try {
        const response = await AlertasDataService.getGeofencesGroupedByDates(data, this.key);
        const alerts = await Crypto.desencriptar(response.data, this.key);
        const totalAlerts = this.getTotalAlerts(alerts);

        this.isAlertsAvailables = totalAlerts > 0;
        if (this.isAlertsAvailables) {
          this.fechasss = data;
          this.geocercasArray = alerts;
          this.lbltotalAlertas = totalAlerts;
        }
      } catch (error) {
        console.error("Error al obtener las ultimas alertas de geocercas de entrada y salida: ", error);
        Utils.generalSweetAlert(this.$t('Gral.msgErrorDesconocido'), 'error');
      }
    },

    async fetchAlertsAndGeofences() {
      const data = {
        id: this.idDispositivo,
        fechaInicial: this.fecha.inicial,
        fechaFinal: this.fecha.final,
      };

      // Método encargado de obtener las alertas registradas de un dispositivo 
      // dentro de un rango de fechas
      try {
        // Primera petición: Obtener alertas
        const responseAlerts = await AlertasDataService.getAlertsGroupedByDeviceDates(data, this.key);
        const alerts = await Crypto.desencriptar(responseAlerts.data, this.key);
        const totalAlerts = this.getTotalAlerts(alerts);

        this.isAlertsAvailables = totalAlerts > 0;
        if (this.isAlertsAvailables) {
          this.fechasss = data;
          this.alertasByDevice = alerts;
          this.lbltotalAlertas = totalAlerts;
          this.idDevice = data.id;
        }
      } catch (error) {
        console.error("Error al obtener las ultimas alertas registradas de un dispositivo : ", error);
        Utils.generalSweetAlert(this.$t('Gral.msgErrorDesconocido'), 'error');
      }

      // Método encargado de obtener las geocercas registradas de un dispositivo,
      //dentro de un rango de fechas
      try {
        // Segunda petición: Obtener geocercas (se ejecuta siempre)
        const responseGeofences = await AlertasDataService.getGeofencesGroupedByDeviceDates(data, this.key);
        const geofences = await Crypto.desencriptar(responseGeofences.data, this.key);
        const totalGeofences = this.getTotalAlerts(geofences);

        this.isGeosAvailables = totalGeofences > 0;
        if (this.isGeosAvailables) {
          this.fechass = data;
          this.geosByDevice = geofences;
          this.lbltotalAlertass = totalGeofences;
          this.idDevicee = data.id;
        }
      } catch (error) {
        console.error("Error al obtener las ultimas alertas por rango de fechas: ", error);
        Utils.generalSweetAlert(this.$t('Gral.msgErrorDesconocido'), 'error');
      }
    },

    /**
     * Método para enlistar los dispositivos del usuario.
     */
    inputSelect() {
      // 1. Manejo del caso vacío (Early Return)
      if (!this.dispositivosTodos.length) {
        this.handleEmptyDevices();
        return;
      }

      this.banderaSelect = true;

      // 2. Manejo del dispositivo seleccionado
      if (this.selectedDispositivo) {
        const { id, imei, nombre } = this.selectedDispositivo; // Destructuración para claridad

        this.nombreDispositivo = nombre;
        this.idDispositivo = id;
        this.isDeviceSelected = true;

        // Persistencia (separada de la emisión de eventos)
        sessionStorage.setItem("imei", imei);
        sessionStorage.setItem("id", id);

        // Emitir el objeto completo o el ID, no el resultado de setItem
        this.$emit("input", id);
      } else {
        this.isDeviceSelected = false;
      }
    },

    handleEmptyDevices() {
      this.banderaSelect = false;
      this.isDeviceSelected = false;
      // En lugar de mutar el array original con un string, 
      // es mejor manejar el mensaje "No hay registros" en el template (HTML).
      console.warn("No se encontraron dispositivos registrados.");
    },

    /**
     * Método encargado de obtener el total de alertas agrupadas por cada tipo
     * @param alertList lista de alertas
     * @returns total de alertas
     */
    getTotalAlerts(alertList) {
      let total = 0;
      alertList.forEach(alert => {
        total += Object.values(alert[1]).reduce((a, b) => a + b, 0);
      });
      return total;
    },

    /**
     * Método encargado de limpiar los valores de los componentes
     * que tienen valores necesarios para renderizar o realizar
     * cálculos primordiales.
     */
    managerReset() {
      this.selectedDispositivo = null;
      this.modelDateRange = null;
      this.filterType = 'byLatest';
      this.isClic = false;
      this.isDeviceSelected = false;
      this.isAlertsAvailables = false;
      this.isGeosAvailables = false;
    },

    /**
     * Método encargado de limpiar los valores de los componentes
     * que tienen valores necesarios para renderizar o realizar
     * cálculos primordiales.
     * @param {*} viewGeneral 
     */
    limpiarCampos(viewGeneral) {
      if (viewGeneral) {
        this.modelDateRange = null;
        this.isClic = false;
      }
    },

    /** Método encargado de obtener todos los dispositivos asignados
    * al usuario actual, tomando en cuenta que esto solo aplica para
    * master y administradores.*/
    async getDevices() {
      try {
        const response = await DevicesDataService.getAllOrden();
        this.dispositivosTodos = await Crypto.desencriptar(response.data, this.key);
        if (sessionStorage.idRol === process.env.VUE_APP_ID_MASTER && sessionStorage.getItem("usuarioFiltro") !== "") {
          const user = JSON.parse(sessionStorage.getItem("usuarioFiltro"));
          const isAdmin = user.rol.id === process.env.VUE_APP_ID_ADMINISTRADOR;

          this.dispositivosTodos = this.dispositivosTodos.filter((value) => {
            if (isAdmin) {
              return value.area?.id === user.area.id;
            } else {
              return value.usuarios?.some((val) => val.id === user.id);
            }
          });
        }
        this.banderaSelect = this.dispositivosTodos.length > 0;
        if (!this.banderaSelect) {
          Utils.customizedAlert(this.$t('vMonitoreo.msgSinDispositivos'), this.$t('vEstadisticas.msgErrorVerActividad'), 'warning', 'gray');
        }
      } catch (error) {
        console.error("Error al obtener los dispositivos: ", error)
        Utils.generalSweetAlert('Error al buscar dispositivos.', 'error');
      }
    },

    // === SECCIÓN DE METODOS SECUNDARIOS === //
    /** Método encargado de traducir propiedades de componentes
    * @param value lista de elementos a traducir
    * @returns elemento traducido
    */
    translateOptions(value) {
      return value.map(option => {
        if (typeof option === 'object' && option.text) {
          return {
            ...option,
            text: this.$t(`vEstadisticas.${option.text}`)
          };
        }
      })
    },
  }
}
</script>

<style scoped>
.form-control {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0;
  font-size: none;
  font-weight: none;
  line-height: none;
  color: none;
  background-color: #fff;
  background-clip: padding-box;
  border: none;
  border-radius: none;
  transition: none;
}

.headTab {
  font-size: 20px;
  text-align: center;
}

.alerta {
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  font-weight: bold;
}

.alert {
  height: 300px;
  position: block;
  text-align: center;
  font-size: 30px;
  font-weight: bold;
}

.alert img {
  display: block;
  margin: 0 auto;
  height: 550px;
}

.alert span {
  position: absolute;
  /* Posición absoluta en relación con .contenedor */
  top: 50%;
  /* Centrado verticalmente */
  left: 50%;
  /* Centrado horizontalmente */
  transform: translate(-50%, -50%);
  /* Centrado exacto en ambas direcciones */
  background-color: rgba(181, 128, 128, 0.5);
  /* Opcional: fondo para resaltar el texto */
  padding: 0.9rem;
}

.container-general {
  display: flex;
  justify-content: center;
}

.container-apex {
  width: 60%;
}

.container-empty {
  width: 100%;
  margin: 10px;
}

@media (max-width: 760px) {
  .container-apex {
    width: 100%;
  }
}

@media (max-width: 992px) {
  .alert {
    font-size: 25px;
  }
}

@media screen and (max-width: 768px) {
  .separacion-div-rango-fecha {
    margin-top: -14px;
  }

  .separacion-div-boton-buscar {
    margin-top: -10px;
  }
}

@media screen and (max-width: 768px) {
  .separacion-div-boton-buscar-dispo {
    margin-top: -2.6rem;
  }
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>